module.exports = __webpack_public_path__ + "img/logo_white.023f5468.png";